import React from "react";
import { Badge, Box } from "@mui/material";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import LeftFilters from "./LeftFilters";
import RightFilters from "./RightFilters";
import DownloadAuditReport from "../../../Client/detail/components/Units/DownloadAuditReport";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { downloadAuditReport, downloadPendingMailer } from "../../../../sevices/leadComplianceApi";
import PrimaryButton from "../../../../components/Button/Button";
import { useSelector } from "react-redux";
import ComplianceYear from "../Header/ComplianceYear";
import { isAdmin, isSelfService } from "../../../../utils/helpers";
import MailerToSend from "../Header/Download/MailerToSend";
import MailerForReview from "../Header/Download/MailerForReview";

function Filters({ building, client, isFilterHide =false}) {
  const statusCount = useSelector((state) => state.compliance.count);
  const is_self_service = isSelfService();
  return (
    <>
      <div className="tickets-filter  bg-white">
        <div
          className={`d-flex align-items-center justify-content-space-between ${
            !isFilterHide ? "filter-border" : ""
          } filter-paddings filter-bottom-paddings`}
        >
          <ComplianceYear name={"Compliance Year"} />
          <div className="d-flex">
            <RightFilters complianceType={"mailer_program"} selfServiceFilter={true}/>
            {(isAdmin() || is_self_service) && (
              <>
                {isAdmin() && (
                  <MailerToSend
                    btnTitle={"Mailers to Send"}
                    downloadCallback={downloadPendingMailer}
                    pdfName={"annual-report-mailer-to-send.pdf"}
                  />
                )}
                <MailerForReview
                  btnTitle={isAdmin() ? "Mailers for Review" : "Print Notices"}
                  downloadCallback={downloadPendingMailer}
                  pdfName={"annual-report-mailer-for-review.pdf"}
                />
              </>
            )}
          </div>
        </div>
        {!isFilterHide && (
          <div className="d-flex align-items-center justify-content-space-between filter-top-paddings">
            <LeftFilters />
            <PrimaryButton
              variant="contained"
              className={`capitalize`}
              disabled={true}
            >
              Returned Notices
              <Chip
                label={
                  (statusCount?.completed ?? 0) + (statusCount?.in_process ?? 0)
                }
                size="small"
                color="success"
                sx={{ backgroundColor: "#11b50c66 !important" }}
                className="ml-1"
              />
            </PrimaryButton>
          </div>
        )}
      </div>
    </>
  );
}

export default Filters;
